import React, { Component } from 'react'

class GuestsInputForm extends Component {

    render(){
        const {
            personalData,
            guests,
            errorMessages,
            disabled,
            handlePersonalDataChange,
            handleGuestInputChange
        } = this.props
        return(
            <div className="guest-reservation-block">
                <div className="personal-data-block">
                    <div className="line-header-text">Datos personales</div>
                    <table>
                    <tbody>
                        <tr>
                            <th className="table-left">Nombre</th>
                            <th className={errorMessages.personalDataName ? "input-error-container" : "input-block"}>
                            <div className="input-error">
                                <input
                                    type="text"
                                    className="text-input"
                                    value={personalData.name}
                                    disabled={disabled}
                                    onChange={
                                        event => handlePersonalDataChange(
                                            event.target.value,
                                            personalData.phone,
                                            personalData.mail,
                                            personalData.plate
                                        )
                                    }
                                />
                            </div>
                            </th>
                        </tr>
                        <tr>
                            <th className="table-left">Teléfono</th>
                            <th className={errorMessages.personalDataPhone ? "input-error-container" : "input-block"}>
                            <div className="input-error">
                                <input
                                    type="text"
                                    className="text-input"
                                    value={personalData.phone}
                                    disabled={disabled}
                                    onChange={
                                        event => handlePersonalDataChange(
                                            personalData.name,
                                            event.target.value,
                                            personalData.mail,
                                            personalData.plate
                                        )
                                    }
                                />
                            </div>
                            </th>
                        </tr>
                        <tr>
                            <th className="table-left">Correo electrónico</th>
                            <th className={errorMessages.personalDataMail ? "input-error-container" : "input-block"}>
                            <div className="input-error">
                                <input
                                    type="text"
                                    className="text-input"
                                    value={personalData.mail}
                                    disabled={disabled}
                                    onChange={
                                        event => handlePersonalDataChange(
                                            personalData.name,
                                            personalData.phone,
                                            event.target.value,
                                            personalData.plate
                                        )
                                    }
                                />
                            </div>
                            </th>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div className="guests-block">
                    <div className="line-header-text">Nombres de acompañantes</div>
                    <div>
                    <table>
                    <tbody>
                    {
                        guests.map((guest, index) => {
                                return (
                                    <tr>
                                        <td>
                                            <div className={`horizontal-block ${errorMessages.guests[index] ? "input-error-container" : "input-block"}`}>
                                                <div className="input-error">
                                                    <input
                                                        type="text"
                                                        value={guest.name}
                                                        className="text-input"
                                                        disabled={disabled}
                                                        onChange={
                                                            event => handleGuestInputChange(index, event.target.value)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            }
                        )
                    }
                    </tbody>
                    </table>
                    </div>
                </div>
            </div>
        )
    }

}
export default GuestsInputForm
